import ElementConfig from '../classes/definitions/formItem/ElementConfig';
import FormItem from '../classes/definitions/formItem/FormItem';
var paymentMethodSchema = {
    bg_name: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'text',
        }),
        elementType: 'input',
        label: 'Име на български *',
        value: '',
        validation: {
            required: true
        },
        valid: false,
        touched: false,
        errorMsg: 'Моля, въвдете валидно име на български',
    }),
    en_name: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'text',
        }),
        elementType: 'input',
        label: 'Име на английски *',
        value: '',
        validation: {
            required: true
        },
        valid: false,
        touched: false,
        errorMsg: 'Моля, въвдете валидно име на английски',
    }),
    active: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
        }),
        elementType: 'inputSwitch',
        label: 'Активен',
        value: '',
        validation: {
            required: false
        },
        valid: false,
        touched: false,
        errorMsg: '',
    }),
    online_payment: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
        }),
        elementType: 'inputSwitch',
        label: 'Онлайн плащане',
        value: '',
        validation: {
            required: false
        },
        valid: false,
        touched: false,
        errorMsg: '',
    }),
};
export default paymentMethodSchema;



//////////////////
// WEBPACK FOOTER
// ./src/schemas/paymentMethodSchema.ts
// module id = 398
// module chunks = 0